import { NgClass } from '@angular/common';
import { RouterLink } from '@angular/router';
import { Component, input } from '@angular/core';

import { Article } from '@models/article';
import { AssetFormatterPipe } from '@pipes/asset-formatter-pipe';

@Component({
  imports: [NgClass, RouterLink, AssetFormatterPipe],
  selector: 'app-content',
  styleUrl: './content.scss',
  templateUrl: './content.html',
})
export class Content {
  items = input<Article[]>([]);
}
